import type { EmailStatusPayload } from './auth-api';

export type UnavailableAccountTranslationKey =
  | 'login.accountDeleted'
  | 'login.accountUnavailable';

/**
 * The wire shape: `isPartner` only exists on API builds that ship the partner
 * platform, so it stays optional until normalization fills it in.
 */
export type RawEmailStatusPayload = Omit<EmailStatusPayload, 'isPartner'> & {
  isPartner?: boolean;
};

export function normalizeEmailStatusPayload(
  payload: RawEmailStatusPayload,
): EmailStatusPayload {
  return { ...payload, isPartner: payload.isPartner === true };
}

export function isEmailAccountUnavailable(
  status: Pick<EmailStatusPayload, 'exists' | 'canAuthenticate'>,
) {
  return status.exists && !status.canAuthenticate;
}

/**
 * Non-blocking signal: a partner account can still sign in to the normal app,
 * it just gets pointed at partners.tabbio.com for partner work.
 */
export function isPartnerAccount(
  status: Pick<RawEmailStatusPayload, 'isPartner'>,
) {
  return status.isPartner === true;
}

export function getUnavailableAccountTranslationKey(
  accountStatus: string,
): UnavailableAccountTranslationKey {
  return accountStatus === 'deleted'
    ? 'login.accountDeleted'
    : 'login.accountUnavailable';
}
